import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { Title as AlertTitle } from 'components/AlertBottomSheet/styles';
import Button from 'components/Buttons/Button';

interface ContainerProps {
  twoColumns?: boolean;
  multipleColumns?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  border: 1px solid ${ColorPalette.HEX.BrightGray};
  background-color: ${({ theme }) => theme.listPreviewCard.white};
  height: fit-content;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: ${({ multipleColumns, twoColumns }) => (!multipleColumns || twoColumns ? 'none' : 'calc(50% - 16px)')};
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  margin-top: 32px;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 500px;
    margin-left: auto;
  }

  @media ${({ theme }) => theme.device.mobile} {
    background: ${ColorPalette.HEX.White};
    width: 100%;
    align-items: center;
    justify-content: center;
    position: fixed;
    padding: 16px;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;

export const StyledButton = styled(Button)`
  height: auto;
  min-height: 55px;
  font-size: 16px;
  line-height: initial;
  padding: 14px;

  @media ${({ theme }) => theme.device.mobile} {
    margin: 0px 16px 32px 16px;
  }
`;

export const BoxContainer = styled.div`
  display: flex;
  height: 80px;
  align-items: center;
  padding: 0 24px;
  width: 100%;
  border: 1px ${({ theme }) => theme.rule.ruleList.lightGrey};
  border-style: solid none;
  background-color: ${({ theme }) => theme.rule.ruleList.white};

  @media ${({ theme }) => theme.device.desktop} {
    margin-bottom: 16px;
    border: none;
  }
`;

export const ButtonGhost: any = styled.button`
  display: flex;
  background-color: ${({ theme }) => theme.rule.ruleList.white};
  background: none;
  border: none;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.rule.ruleList.primary};
  cursor: pointer;
`;

ButtonGhost.Icon = styled.img`
  margin-right: 8px;
`;

export const SubTitle = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.rule.greyLight};
  text-align: center;
  font-weight: normal;
`;

export const SectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  max-width: 1300px;
  min-height: 100%;

  @media ${({ theme }) => theme.device.mobile} {
    background-color: ${({ theme }) => theme.group.whiteGrey};
    max-width: none;
  }

  ${AlertTitle} {
    color: ${ColorPalette.HEX.Red};
  }
`;

export const Content = styled.div`
  padding: 24px 16px 0;
  margin-bottom: 16px;

  & h3 {
    font-size: 14px;
    color: ${({ theme }) => theme.groupedList.item.textColor};
    font-weight: 600;
  }
  & p {
    font-size: 14px;
    color: ${({ theme }) => theme.groupedList.item.textColor};
  }

  ${Container} {
    margin-top: 16px;
  }
  h3 + ${Container} {
    margin-top: 0;
  }
  & + & {
    padding-top: 8px;
  }

  @media ${({ theme }) => theme.device.desktop} {
    padding: 24px 0;
    margin-bottom: 0;
  }
`;

export const Title = styled.h2`
  font-weight: 600;
  font-size: 20px;
  margin: 30px 16px 0;
  color: ${({ theme }) => theme.group.section.title};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  line-height: 1.4em;

  @media ${({ theme }) => theme.device.desktop} {
    margin: 30px 0;
  }
`;

export const Spacer = styled.div`
  margin-bottom: 90px;
  width: 100%;

  @media ${({ theme }) => theme.device.desktop} {
    margin-bottom: 0;
  }
`;

export const TextModal = styled.span`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => theme.travelApproval.modal.modalTextColor};

  & > strong {
    font-weight: 600;
  }
`;
